module.exports = __webpack_public_path__ + "img/download.1dfc4954.svg";